import { useEffect } from 'react';
import { useGridApiRef } from '@mui/x-data-grid';
import { GridInitialStateCommunity } from '@mui/x-data-grid/models/gridStateCommunity';
import { atom, useAtom } from 'jotai';

const apiRefAtom = atom<{ [id: string]: GridInitialStateCommunity }>({});

export const useDataGridStatePersistor = (id: string) => {
  const apiRef = useGridApiRef();
  const [gridState, setGridState] = useAtom(apiRefAtom);

  const persistState = (state: GridInitialStateCommunity) => {
    if (state) {
      setGridState((old) => ({
        ...old,
        [id]: state,
      }));
    }
  };

  useEffect(() => {
    const apiRefCurrent = apiRef.current;
    const state = gridState[id];

    if (state) {
      apiRefCurrent.restoreState(state);
    }

    return () => {
      const newState = apiRefCurrent.state;
      persistState(newState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { apiRef };
};
